import { defineMessages } from 'react-intl';

export const i18n: {
	contributor: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	confluenceFilterContributorPlaceholder: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	confluenceFilterContributorLabelSelected: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	confluenceFilterContributorLabelUnselected: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	contributor: {
		id: 'search-page.filters.names.contributor',
		defaultMessage: 'Contributor',
		description: 'Label for filtering by contributor',
	},
	confluenceFilterContributorPlaceholder: {
		id: 'search-page.confluence.filter.contributor.placeholder',
		defaultMessage: 'Find people',
		description: 'Placeholder for contributor filter search input',
	},
	confluenceFilterContributorLabelSelected: {
		id: 'search-page.confluence.filter.contributor.label.selected',
		defaultMessage: 'Selected',
		description: 'Confluence filter label selected',
	},
	confluenceFilterContributorLabelUnselected: {
		id: 'search-page.confluence.filter.contributor.label.unselected',
		defaultMessage: 'Suggested',
		description: 'Confluence filter label unselected',
	},
});
